import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import Input from "../input/Input";
import Label from "../other/label";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  setSecurtitesTrading,
  setpoliticianTrading,
  setCompanyName,
  setCompanyDesignation,
  removeCompanyDetails,
  setCompanyDesignationDesc,
  setDesignationOthers,
  removeCompanyRelationDetails
} from "../../redux/occupationSlice";
import { useState, useEffect, useRef } from "react";
import ApiService from "../service/apiService";
import { useForm, Controller } from "react-hook-form";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { NextButton, PrevButton } from "./kycSidebar";
import { classNames } from "primereact/utils";
import { DynamicFieldSection } from "./personalDetails";
import { SaveButton } from "./declerationDetails";
import { useToast } from "../other/Toast";
import { getTValue } from "../other/label";
import InputText from "../other/InputText";
import LookupService from "../service/lookupService";
import { setDesignationList } from "../../redux/lookupSlice";
import { confirmDialog } from "primereact/confirmdialog";
import { setAntiMoneyLaundering, setBeneficiaryNameError, setBeneficiaryRelationError, setFelonyError, setRelatedHighRankingOfficialNameError, setRelatedHighRankingOfficialRelationError } from "../../redux/moneyLaunderingPreventionSlice";
import { alphabetChecker } from "../../helper/validationHelper";

//http://localhost:3000/admin/kyc/0/money-laundering-prevention

const footer = () => (
  <div class=" p-field p-col-12 p-md-12">
    <div
      className="p-grid"
      style={{ display: "flex", flex: 3.5, padding: "0 10px" }}
    >
      <div style={{ flex: 1 }}>
        <PrevButton />
      </div>
      <div style={{ flex: 1.5 }}>
        <center>
          <SaveButton />
        </center>
      </div>
      <div style={{ flex: 1 }}>
        <center>
          <NextButton />
        </center>
      </div>
    </div>
  </div>

);

function MoneyLaunderingPrevention() {
  const { t, i18n } = useTranslation();



  const antiMoneyLaundering = useSelector(
    (state) => state.moneyLaunderingDetails
  );
  const errors = useSelector(
    (state) => state.moneyLaunderingDetails.errors
  );


  const handleChange = (e) => {
    // const { highRankingOfficial, relatedHighRankingOfficial, relatedHighRankingOfficialName,
    //    relatedHighRankingOfficialRelation, beneficiary, beneficiaryName,
    //     beneficiaryRelation, felonyState, felony } = e.target;
    const { name, value } = e.target;
    dispatch(setAntiMoneyLaundering({ name, value }));
  };


  const [formData, setFormData] = useState({
    highRankingOfficial: '',
    relatedHighRankingOfficial: '',
    relatedHighRankingOfficialName: '',
    relatedHighRankingOfficialRelation: '',
    beneficiary: '',
    beneficiaryName: '',
    beneficiaryRelation: '',
    felonyState: '',
    felony: '',
  });



  const [loadingo, setLoadingo] = useState(false);
  const [loadingd, setLoadingd] = useState(false);

  const dispatch = useDispatch();
  const [relationTypeList, setRelationTypeList] = useState([]);

  const lookupDesignationList = useSelector(
    (state) => state.lookupDetails.designationList
  );

  const maritalStatus = useSelector((state) => state.personalDetails.maritalStatus);

  useEffect(() => {
    setLoadingo(true);
    setLoadingd(true);

    ApiService.getRelationTypeList().then((response) => {
      const nRelation = response && response.data && response.data.data;
      setRelationTypeList(nRelation);
    });

    ApiService.getDesignationList().then((response) => {
      console.log(response.data);
      setDesignationList(response.data.data);
    }).finally(() => setLoadingd(false));




    if (!lookupDesignationList) {
      LookupService.getDesignationList(dispatch);
    }
  }, []);

  const {
    control,
    // formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const getFormErrorMessage = (name) => {
    console.log("regggggmi", errors);
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  return (
    <Card
      className="p-col-12 p-md-12 main-card"
      header={
        <h3 className="p-col-12 p-md-12 text-center">
          <i className="pi pi-briefcase" /> {t("moneyLaunderingPrevention")}
        </h3>
      }
      footer={footer}
    >

      <div className="p-grid p-fluid p-col-12 p-md-12" style={{ margin: 0 }}>

        <div className="p-field p-col-12 p-md-12 ">
          <label
            className="p-col-12 p-md-12"
            htmlFor="politician"
            style={{ textAlign: "center" }}
          >
            {t("politician")}*
          </label>
          <div
            className="p-grid p-field p-col-12 p-md-12"
            style={{ padding: 0, margin: 0 }}
          >
            <div
              className="p-field-radiobutton p-col-12 p-md-12"
              style={{ justifyContent: "center" }}
            >
              <Controller
                name="highRankingOfficial"
                control={control}
                rules={{ required: "Politician High Ranking is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    value={true}
                    onChange={(e) => handleChange({ target: { name: field.name, value: e.value } })}
                    checked={antiMoneyLaundering?.highRankingOfficial}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              <label
                htmlFor="securitiesTradingYes"
                style={{ marginRight: "10px" }}
              >
                {t("xa")}
              </label>
              <Controller
                name="highRankingOfficial"
                control={control}
                rules={{ required: "Securtites Trading is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    value={false}
                    onChange={(e) => handleChange({ target: { name: "highRankingOfficial", value: e.value } })}
                    checked={antiMoneyLaundering?.highRankingOfficial === false}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />

              <label
                htmlFor="securitiesTradingYes"
                style={{ marginRight: "10px" }}
              >
                {t("xaina")}
              </label>
            </div>
          </div>
          {getFormErrorMessage("highRankingOfficial")}
        </div>
        <div className="p-field p-col-12 p-md-12 ">
          <label
            className="p-col-12 p-md-12"
            htmlFor="securtitesTrading"
            style={{ textAlign: "center" }}
          >
            {t("relatedP")}*

          </label>
          <div
            className="p-grid p-field p-col-12 p-md-12"
            style={{ padding: 0, margin: 0 }}
          >
            <div
              className="p-field-radiobutton p-col-12 p-md-12"
              style={{ justifyContent: "center" }}
            >
              <Controller
                name="relatedPolitician"
                control={control}
                rules={{ required: "Securtites Trading is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    value={true}
                    onChange={(e) => handleChange({ target: { name: "relatedHighRankingOfficial", value: e.value } })}
                    checked={antiMoneyLaundering?.relatedHighRankingOfficial}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              <label
                htmlFor="securitiesTradingYes"
                style={{ marginRight: "10px" }}
              >
                {t("xa")}
              </label>
              <Controller
                name="relatedPolitician"
                control={control}
                rules={{ required: "Securtites Trading is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    value={false}
                    onChange={(e) => handleChange({ target: { name: "relatedHighRankingOfficial", value: e.value } })}
                    checked={antiMoneyLaundering?.relatedHighRankingOfficial === false}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              <label
                htmlFor="securitiesTradingYes"
                style={{ marginRight: "10px" }}
              >
                {t("xaina")}
              </label>
            </div>
          </div>
          {getFormErrorMessage("relatedHighRankingOfficial")}
        </div>
        {antiMoneyLaundering?.relatedHighRankingOfficial ? (
          <>
            <div className="p-field p-col-12 p-md-7 stick-right">
              <label className="p-col-12 p-md-12" htmlFor="relatedPYes">
                {t("relatedPYes")}*
              </label>
              {/* <Controller
                name="relatedHighRankingOfficialName"
                control={control}
                rules={{ required: "Company Name is required." }}
                render={({ field, fieldState }) => (
                  <InputText
                    id={field.name}
                    {...field}
                    isName
                    keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                    placeholder={t("name")}
                    onChange={(e) => handleChange(e)}
                    value={antiMoneyLaundering?.relatedHighRankingOfficialName}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              {getFormErrorMessage("relatedHighRankingOfficialName")} */}
              <Controller
                name="relatedHighRankingOfficialName"
                control={control}
                rules={{ required: "Company Name is required." }}
                render={({ field, fieldState }) => (
                  <InputText
                    id={field.name}
                    {...field}
                    isName
                    keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                    placeholder={t("name")}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => {
                      const value = e.target.value.trim(); // Trim to handle whitespace-only values
                      if (!value) {
                        dispatch(setRelatedHighRankingOfficialNameError({
                          message: "Related High Ranking Official Name can't be empty.",
                          section: "MLD",
                        }));
                      }
                      else if (!alphabetChecker(value)) {
                        dispatch(setRelatedHighRankingOfficialNameError({
                          message: "Related High Ranking Official Name should be in alphabet characters only",
                          section: "MLD",
                        }));
                      }
                      else {
                        dispatch(setRelatedHighRankingOfficialNameError({
                          message: null,
                          section: "MLD",
                        }));
                      }
                    }}
                    value={antiMoneyLaundering?.relatedHighRankingOfficialName}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              {getFormErrorMessage("relatedHighRankingOfficialNameError")}
            </div>
            <div className="p-field p-col-12 p-md-5 stick-left">
              <label className="p-col-12 p-md-12" htmlFor="relatedHighRankingOfficialRelation">
                {t("relation")}
              </label>
              {/* <Controller
                name="relatedHighRankingOfficialRelation"
                control={control}
                rules={{ required: "Designation is required." }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    id={field.id}
                    {...field}
                    value={antiMoneyLaundering?.relatedHighRankingOfficialRelation}
                    filter showClear
                    disabled={loadingd}
                    dropdownIcon={loadingd ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}

                    onChange={(e) => handleChange(e)}
                    options={relationTypeList}
                    optionLabel={(data) =>
                      getTValue(i18n, data.descEng, data.descNep)
                    }
                    placeholder={t("relation")}
                    optionValue="code"
                  />
                )}
              />
              {getFormErrorMessage("relatedHighRankingOfficialRelation")} */}
              <Controller
                name="relatedHighRankingOfficialRelation"
                control={control}
                rules={{ required: "Designation is required." }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    id={field.id}
                    {...field}
                    value={antiMoneyLaundering?.relatedHighRankingOfficialRelation}
                    filter showClear
                    disabled={loadingd}
                    dropdownIcon={loadingd ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}

                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => {
                      const value = antiMoneyLaundering?.relatedHighRankingOfficialRelation;
                      if (!value) {
                        dispatch(setRelatedHighRankingOfficialRelationError({
                          message: "High Ranking Official Relation can't be empty.",
                          section: "MLD",
                        }));
                      } else {
                        dispatch(setRelatedHighRankingOfficialRelationError({
                          message: null,
                          section: "MLD",
                        }));
                      }
                    }}
                    options={relationTypeList}
                    optionLabel={(data) =>
                      getTValue(i18n, data.descEng, data.descNep)
                    }
                    placeholder={t("relation")}
                    optionValue="code"
                  />
                )}
              />
              {getFormErrorMessage("relatedHighRankingOfficialRelationError")}
            </div>

            <div className="p-col-12 p-md-12">
              <div className="p-grid">
                <div
                  className="p-col-12 p-md-12"
                  style={{ display: "flex", justifyContent: "flex-end" }}>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}


        <div className="p-field p-col-12 p-md-12 ">
          <label
            className="p-col-12 p-md-12"
            htmlFor="securtitesTrading"
            style={{ textAlign: "center" }}
          >
            {t("hasBeneficiary")}*

          </label>
          <div
            className="p-grid p-field p-col-12 p-md-12"
            style={{ padding: 0, margin: 0 }}
          >
            <div
              className="p-field-radiobutton p-col-12 p-md-12"
              style={{ justifyContent: "center" }}
            >
              <Controller
                name="beneficiary"
                control={control}
                rules={{ required: "Beneficiary name and relation is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    value={true}
                    onChange={(e) => handleChange({ target: { name: "beneficiary", value: e.value } })}
                    checked={antiMoneyLaundering?.beneficiary}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              <label
                htmlFor="securitiesTradingYes"
                style={{ marginRight: "10px" }}
              >
                {t("xa")}
              </label>
              <Controller
                name="beneficiary"
                control={control}
                rules={{ required: "Beneficiary name and relation is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    value={false}
                    onChange={(e) => handleChange({ target: { name: "beneficiary", value: e.value } })}
                    checked={antiMoneyLaundering?.beneficiary === false}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              <label
                htmlFor="securitiesTradingYes"
                style={{ marginRight: "10px" }}
              >
                {t("xaina")}
              </label>
            </div>
          </div>
          {getFormErrorMessage("beneficiary")}
        </div>

        {antiMoneyLaundering?.beneficiary ? (
          <>
            <div className="p-field p-col-12 p-md-7 stick-right">
              <label className="p-col-12 p-md-6" htmlFor="companyName">
                {t("bName")}*
              </label>
              {/* <Controller
                name="beneficiaryName"
                control={control}
                rules={{ required: "Beneficiary Name is required." }}
                render={({ field, fieldState }) => (
                  <InputText
                    id={field.name}
                    {...field}
                    isName
                    keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                    placeholder={t("bName")}
                    onChange={(e) => handleChange(e)}
                    value={antiMoneyLaundering?.beneficiaryName}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              {getFormErrorMessage("beneficiaryName")} */}
              <Controller
                name="beneficiaryName"
                control={control}
                rules={{ required: "Beneficiary Name is required." }}
                render={({ field, fieldState }) => (
                  <InputText
                    id={field.name}
                    {...field}
                    isName
                    keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                    placeholder={t("bName")}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => {
                      const value = e.target.value.trim(); // Trim to handle whitespace-only values
                      if (!value) {
                        dispatch(setBeneficiaryNameError({
                          message: "Beneficiary Name can't be empty.",
                          section: "MLD",
                        }));
                      }
                      else if (!alphabetChecker(value)) {
                        dispatch(setBeneficiaryNameError({
                          message: "Beneficiary Name should be in alphabet characters only",
                          section: "MLD",
                        }));
                      }
                      else {
                        dispatch(setBeneficiaryNameError({
                          message: null,
                          section: "MLD",
                        }));
                      }
                    }}
                    value={antiMoneyLaundering?.beneficiaryName}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              {getFormErrorMessage("beneficiaryNameError")}
            </div>

            <div className="p-field p-col-12 p-md-5 stick-left">
              <label className="p-col-12 p-md-12" htmlFor="companyDesgination">
                {t("relation")}
              </label>
              {/* <Controller
                name="beneficiaryRelation"
                control={control}
                rules={{ required: "Beneficiary Relation is required." }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    id={field.id}
                    {...field}
                    value={antiMoneyLaundering?.beneficiaryRelation}
                    filter showClear
                    disabled={loadingd}
                    dropdownIcon={loadingd ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                    onChange={(e) => handleChange(e)}
                    options={relationTypeList}
                    optionLabel={(data) =>
                      getTValue(i18n, data.descEng, data.descNep)
                    }
                    placeholder={t("relation")}
                    optionValue="code"
                  />
                )}
              />
              {getFormErrorMessage("beneficiaryRelation")} */}
              <Controller
                name="beneficiaryRelation"
                control={control}
                rules={{ required: "Beneficiary Relation is required." }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    id={field.id}
                    {...field}
                    value={antiMoneyLaundering?.beneficiaryRelation}
                    filter showClear
                    disabled={loadingd}
                    dropdownIcon={loadingd ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => {
                      const value = antiMoneyLaundering?.beneficiaryRelation; // Trim to handle whitespace-only values
                      if (!value) {
                        dispatch(setBeneficiaryRelationError({
                          message: "Beneficiary Relation can't be empty.",
                          section: "MLD",
                        }));
                      }
                      else {
                        dispatch(setBeneficiaryRelationError({
                          message: null,
                          section: "MLD",
                        }));
                      }
                    }}
                    options={relationTypeList}
                    optionLabel={(data) =>
                      getTValue(i18n, data.descEng, data.descNep)
                    }
                    placeholder={t("relation")}
                    optionValue="code"
                  />
                )}
              />
              {getFormErrorMessage("beneficiaryRelationError")}
            </div>


            <div className="p-col-12 p-md-12">
              <div className="p-grid">
                <div
                  className="p-col-12 p-md-12"
                  style={{ display: "flex", justifyContent: "flex-end" }}>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}


        {/* 4 */}

        <div className="p-field p-col-12 p-md-12 ">
          <label
            className="p-col-12 p-md-12"
            htmlFor="securtitesTrading"
            style={{ textAlign: "center" }}
          >
            {t("felony")}*
          </label>
          <div
            className="p-grid p-field p-col-12 p-md-12"
            style={{ padding: 0, margin: 0 }}
          >
            <div
              className="p-field-radiobutton p-col-12 p-md-12"
              style={{ justifyContent: "center" }}
            >
              <Controller
                name="felonyState"
                control={control}
                rules={{ required: "Felony detail is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    value={true}
                    onChange={(e) => handleChange({ target: { name: "felonyState", value: e.value } })}
                    checked={antiMoneyLaundering?.felonyState}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              <label
                htmlFor="felonyState"
                style={{ marginRight: "10px" }}
              >
                {t("xa")}
              </label>
              <Controller
                name="felony"
                control={control}
                rules={{ required: "Securtites Trading is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    value={false}
                    onChange={(e) => handleChange({ target: { name: "felonyState", value: e.value } })}
                    checked={antiMoneyLaundering?.felonyState === false}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
              <label
                htmlFor="securitiesTradingYes"
                style={{ marginRight: "10px" }}
              >
                {t("xaina")}
              </label>
            </div>
          </div>
          {getFormErrorMessage("felonyState")}
        </div>
        {antiMoneyLaundering?.felonyState ? (
          <>
            <div className="p-field p-col-12 p-md-12 stick-right nepali-font">
              <label className="p-col-12 p-md-12" htmlFor="companyName">
                {t("felonyName")}*
              </label>
              {/* <Controller
                name="felony"
                control={control}
                rules={{ required: "Felony detail is required." }}
                render={({ field, fieldState }) => (
                  <InputText
                    id={field.name}
                    {...field}
                    isName
                    keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                    placeholder={t("offences")}
                    onChange={(e) => handleChange(e)}
                    value={antiMoneyLaundering?.felony}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              /> */}
              <Controller
                name="felony"
                control={control}
                rules={{ required: "Felony detail is required." }}
                render={({ field, fieldState }) => (
                  <InputText
                    id={field.name}
                    {...field}
                    isName
                    keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                    placeholder={t("offences")}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => {
                      const value = e.target.value.trim(); // Trim to handle whitespace-only values
                      if (!value) {
                        dispatch(setFelonyError({
                          message: "Felony detail name can't be empty.",
                          section: "MLD",
                        }));
                      }
                      else if (!alphabetChecker(value)) {
                        dispatch(setFelonyError({
                          message: "Felony detail should be in alphabet characters only",
                          section: "MLD",
                        }));
                      }
                      else {
                        dispatch(setFelonyError({
                          message: null,
                          section: "MLD",
                        }));
                      }
                    }}
                    value={antiMoneyLaundering?.felony}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                  />
                )}
              />
            </div>

            <div className="p-col-12 p-md-12">
              <div className="p-grid">
                <div
                  className="p-col-12 p-md-12"
                  style={{ display: "flex", justifyContent: "flex-end" }}>
                </div>
              </div>
              {getFormErrorMessage("felonyError")}
            </div>
          </>
        ) : (
          ""
        )}

        <>
          <div className="p-mt-3"></div>
        </>
      </div>
      <DynamicFieldSection />
    </Card>
  );
}

export default MoneyLaunderingPrevention;
